<template>
    <ClientLayout>
        <CardPage :section="0" :page="0">
            <p class="headline text-xs-center">Glossary</p>
            <dl class="mb-3">
                <template v-for="entry in glossary">
                    <dt :key="entry.word" class="subheading font-weight-bold">{{ entry.word }}</dt>
                    <dd :key="entry.definition" class="mb-3 ml-3" v-html="entry.definition"></dd>
                </template>
            </dl>
            <v-divider class="my-3"></v-divider>
            <p class="text-xs-center">To read more, go here: <a href="https://sexetc.org/sex-ed/sex-terms/" target="_blank">sexetc.org/sex-ed/sex-terms</a></p>
            <template v-slot:actions>
                <v-spacer></v-spacer>
            </template>
        </CardPage>
    </ClientLayout>
</template>

<script>
export default {
    name: 'Glossary',
    data() {
        return {
            glossary: [
                {
                    word: '69',
                    definition:
                        'The act of two people performing oral sex on each other at the same time. It’s called “69” because the numbers 6 and 9 resemble the physical position of the two partners during this sex act.'
                },
                {
                    word: 'AIDS',
                    definition: 'An acronym that stands for Acquired Immunodeficiency Syndrome; a severe stage of HIV infection.'
                },
                {
                    word: 'ART',
                    definition: 'An acronym that stands for Antiretroviral Therapy, a medication regimen that HIV-positive people take to stay healthy.'
                },
                {
                    word: 'Ass fucking',
                    definition: 'Anal sex, as either the top (insertive partner) or bottom (receptive partner).'
                },
                {
                    word: 'Boo',
                    definition: 'A boyfriend/girlfriend/someone you are dating.'
                },
                {
                    word: 'Bottom',
                    definition:
                        'The person whose anus (butthole) is being penetrated by their sex partner’s penis or dildo during sex. Or more broadly refers to the person who is receiving the stimulus or sexual act.'
                },
                {
                    word: 'Bottoming',
                    definition: 'The act of taking the position of a bottom (receptive partner) during sex.'
                },
                {
                    word: 'Bottom surgery',
                    definition:
                        'Refers to a few different surgeries that trans folks may choose or want to do, including orchiectomy (having your testicles or balls removed), labiaplasty, and vaginoplasty (getting a vagina).'
                },
                {
                    word: 'Cisgender',
                    definition: 'A term to describe someone whose gender is the same as their sex assigned at birth.'
                },
                {
                    word: 'Client',
                    definition: 'Someone who is paying someone else for sex work.'
                },
                {
                    word: 'Condom',
                    definition:
                        'In most cases, a condom is for a penis but there is another kind for buttholes/vaginas, too. A external condom (penis condom) is made of latex or polyurethane and can be rolled over the shaft of a hard penis to prevent semen and pre-cum from entering another person’s body during sex. The internal condom (aka Female Condom® or Receptive Partner Condom), is a polyurethane pouch that has two flexible rings on either end. In vaginal sex, the smaller ring is inserted into the vagina while the bigger ring stays just outside of the vaginal opening (<a href="https://www.cdc.gov/condomeffectiveness/internal-condom-use.html" target="_blank">www.cdc.gov/condomeffectiveness/internal-condom-use.html</a>). In anal sex, the bottom inserts the condom into their butthole by removing the smaller ring. The bigger ring stays outside the body and circles the butthole (<a href="https://youtu.be/9_7H_BMMUvc" target="_blank">youtu.be/9_7H_BMMUvc</a>). Whether it’s in a vagina or a butthole, it’s a good idea that one partner is holding the outer ring in place (especially in the first few moments when a penis is inserted). If someone plans to have both anal and vaginal sex, they can’t use the same Receptive Partner Condom for both holes – use a separate one for each hole.'
                },
                {
                    word: 'Consent',
                    definition:
                        'Consent is an ongoing process of discussing boundaries and what you’re comfortable with. Consent can refer to an agreement between participants to engage in sexual activity. Consent should be clearly and freely communicated. A verbal and affirmative expression of consent can help both you and your partner to understand and respect each other’s boundaries. Consent cannot be given by individuals who are underage, intoxicated or incapacitated by drugs or alcohol, or asleep or unconscious. If someone agrees to an activity under pressure of intimidation or threat, that isn’t considered consent because it was not given freely. Unequal power dynamics, such as engaging in sexual activity with an employee or student, also mean that consent cannot be freely given.'
                },
                {
                    word: 'Dom',
                    definition: 'Stands for Dominant which typically refers to a person who is directing the action, or who has consensual authority/power.'
                },
                {
                    word: 'Dry humping',
                    definition:
                        '(a.k.a. frottage) Can include various sexual activities that don’t involve genital to genital contact. For example, rubbing genitals together with clothes on.'
                },
                {
                    word: 'Eating pussy',
                    definition: 'The act of performing oral sex on a vagina.'
                },
                {
                    word: 'Fisting',
                    definition: 'When someone inserts their hand into someone else’s butt or vagina.'
                },
                {
                    word: 'Gender Fluid',
                    definition:
                        'A person who experiences their gender as more than just totally male or totally female. Tends to refer to people whose gender changes and shifts over time (i.e., their gender is not fixed).'
                },
                {
                    word: 'Genitalia',
                    definition: 'A term to describe the external sexual and reproductive organs (penis, testicles, vagina, etc.)'
                },
                {
                    word: 'Getting/Giving Head (Blowjob)',
                    definition: 'The act of receiving or performing oral sex.'
                },
                {
                    word: 'Getting tied up',
                    definition: 'When someone consensually ties someone else up as part of a sexual encounter.'
                },
                {
                    word: 'Hand job',
                    definition: 'When someone strokes someone else’s penis or genitals.'
                },
                {
                    word: 'HIV',
                    definition: 'An acronym that stands for Human Immunodeficiency Virus; a virus that attacks the immune system and causes AIDS.'
                },
                {
                    word: 'Hormones',
                    definition:
                        'Medications some trans folks choose to take to medically transition gender. Feminizing hormone therapy consists of the sex hormones known as estrogens and antiandrogens.'
                },
                {
                    word: 'Insertive anal sex',
                    definition: 'When you put your penis or dildo in someone’s butt.'
                },
                {
                    word: 'LGBTQ+',
                    definition: 'An acronym that stands for Lesbian, Gay, Bisexual, Transgender, and Queer.'
                },
                {
                    word: 'Mutual masturbation',
                    definition: 'Two or more people masturbating (sexually pleasuring themselves) together.'
                },
                {
                    word: 'Non-binary',
                    definition:
                        'A term to describe any gender that is not exclusively male or female. Common non-binary identities include: agender, gender fluid, genderqueer, two-spirited, etc.'
                },
                {
                    word: 'PEP',
                    definition:
                        'An acronym that stands for Post-Exposure Prophylaxis, which is antiretroviral medication taken to prevent HIV infection after a potential exposure to HIV.'
                },
                {
                    word: 'PrEP',
                    definition:
                        'An acronym that stands for Pre-Exposure Prophylaxis, which is when people at high risk for HIV take a daily antiretroviral pill to lower their chances of getting infected.'
                },
                {
                    word: 'Pumping',
                    definition:
                        'When a person gets silicone (or something they think is silicone) injected into different areas of their body to make them look curvier and/or more feminine.'
                },
                {
                    word: 'Receptive anal sex',
                    definition: 'When someone puts their penis or dildo in your butt.'
                },
                {
                    word: 'Rimming',
                    definition: 'The act of using one’s tongue on the anus (butt) of another person.'
                },
                {
                    word: 'Sex work',
                    definition: 'Exchanging money, food, shelter, etc. for sex.'
                },
                {
                    word: 'Stealth',
                    definition: 'Refers to a person who has decided to pass as cisgender and does not share their gender history with others.'
                },
                {
                    word: 'STI',
                    definition: 'An acronym that stands for Sexually Transmitted Infection. STIs can also be called sexually transmitted diseases (STDs).'
                },
                {
                    word: 'Sub',
                    definition:
                        'Stands for submissive which typically refers to a person who follows the directions of the Dom, and/or consensually hands over authority/power to the Dom.'
                },
                {
                    word: 'Sucking titties',
                    definition: 'Someone putting their mouth on someone else’s breasts or chest.'
                },
                {
                    word: 'Surgeries',
                    definition:
                        'Refers to a range of surgical procedures (changing body tissues or organs) trans folks might decide or want to have to medically transition gender. Can include bottom surgery (see definition above), tracheal shave/thyroid cartilage reduction (to reduce Adam’s Apple), breast augmentation, and other procedures.'
                },
                {
                    word: 'Syringe',
                    definition: 'The needle used to inject hormones or other substances into the body.'
                },
                {
                    word: 'T',
                    definition: 'As in “telling someone my T”, refers to disclosing transgender identity.'
                },
                {
                    word: 'Tittie fucking',
                    definition: 'Someone rubbing their penis between another person’s breasts.'
                },
                {
                    word: 'Toe sucking',
                    definition: 'Someone sucking on someone else’s toes.'
                },
                {
                    word: 'Top',
                    definition:
                        'The person who is using their penis to penetrate the anus (butthole) of a sex partner during sex. Or more broadly refers to the person who is giving the stimulus or doing the sex act.'
                },
                {
                    word: 'Topping',
                    definition: 'The act of taking the position of a top (insertive partner) during anal sex.'
                },
                {
                    word: 'Transgender (or Trans)',
                    definition: 'A term to describe someone whose gender is different from their sex assigned at birth.'
                },
                {
                    word: 'Two-spirited',
                    definition: 'A term for a third gender or other gender-diverse identity used by American Indians and some Alaska Natives.'
                },
                {
                    word: 'Vaginal sex',
                    definition: 'When someone puts their penis or another object into someone’s vagina.'
                },
                {
                    word: 'Vers',
                    definition: 'Stands for versatile and refers to people who top and bottom for various sex acts.'
                },
                {
                    word: 'Viral load',
                    definition:
                        'The amount of HIV in the blood. The more HIV there is in the blood, the greater the risk is for becoming ill because of HIV or passing HIV to others through sex without a condom.'
                },
                {
                    word: 'Water sports',
                    definition: 'Sexual activity that involves someone peeing on someone else.'
                }
            ]
        };
    }
};
</script>
